export interface Category {
  name: string;
  nameEn: string;
  url: string;
  image: string;
  description: string;
}

export const categories: Category[] = [
  {
    name: "Shoes",
    nameEn: "Shoes",
    url: "https://kaspreadsheet.com/category-911-Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20white%20chunky%20sneakers%20placed%20on%20light%20wooden%20surface%20with%20soft%20window%20light%20casting%20gentle%20shadows%2C%20warm%20cream%20background%20wall%2C%20neutral%20earth%20tones%2C%20clean%20Scandinavian%20aesthetic%20style%2C%20high%20detail%20fabric%20texture%20visible%2C%20modern%20editorial%20composition%2C%20no%20clutter&width=800&height=1000&seq=hb-cat-v2-shoes-8a3f&orientation=portrait",
    description: "Tênis, sapatos casuais e esportivos com os melhores preços",
  },
  {
    name: "Hoodies/Sweaters",
    nameEn: "Hoodies",
    url: "https://kaspreadsheet.com/search-912/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20fashion%20flat%20lay%20of%20oversized%20oatmeal%20colored%20hoodie%20neatly%20folded%20on%20light%20linen%20fabric%20surface%2C%20soft%20morning%20light%20from%20side%20window%2C%20warm%20sand%20and%20cream%20tones%2C%20editorial%20style%2C%20visible%20knit%20texture%20details%2C%20simple%20clean%20composition%2C%20modern%20casual%20aesthetic&width=800&height=1000&seq=hb-cat-v2-hoodies-7b2e&orientation=portrait",
    description: "Moletons e suéteres confortáveis para todas as estações",
  },
  {
    name: "T-Shirts",
    nameEn: "T-Shirts",
    url: "https://kaspreadsheet.com/search-913/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20product%20shot%20of%20soft%20washed%20cotton%20tshirt%20in%20warm%20clay%20color%20laid%20flat%20on%20light%20stone%20surface%2C%20diffused%20natural%20daylight%2C%20warm%20neutral%20palette%2C%20editorial%20fashion%20aesthetic%2C%20subtle%20fabric%20wrinkles%20showing%20softness%2C%20clean%20modern%20composition%20with%20negative%20space&width=800&height=1000&seq=hb-cat-v2-tshirts-6c1d&orientation=portrait",
    description: "Camisetas de algodão premium com designs exclusivos",
  },
  {
    name: "Jackets",
    nameEn: "Jackets",
    url: "https://kaspreadsheet.com/search-914/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20fashion%20photography%20of%20olive%20green%20utility%20jacket%20hanging%20on%20wooden%20hanger%20against%20warm%20cream%20plaster%20wall%2C%20soft%20natural%20light%20from%20left%2C%20earthy%20muted%20tones%2C%20sophisticated%20editorial%20style%2C%20fabric%20texture%20details%20visible%2C%20clean%20elegant%20composition%2C%20contemporary%20urban%20aesthetic&width=800&height=1000&seq=hb-cat-v2-jackets-5d0g&orientation=portrait",
    description: "Jaquetas e casacos estilosos para looks urbanos",
  },
  {
    name: "Pants/Shorts",
    nameEn: "Pants",
    url: "https://kaspreadsheet.com/search-915/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20flat%20lay%20of%20beige%20tailored%20wide%20leg%20trousers%20on%20warm%20terracotta%20tile%20floor%2C%20soft%20afternoon%20light%20streaming%20through%20sheer%20curtain%2C%20warm%20earthy%20neutral%20tones%2C%20editorial%20fashion%20style%2C%20visible%20fabric%20drape%20and%20flow%2C%20simple%20elegant%20composition%2C%20mediterranean%20aesthetic&width=800&height=1000&seq=hb-cat-v2-pants-4e9h&orientation=portrait",
    description: "Calças e shorts modernos para qualquer ocasião",
  },
  {
    name: "Headwear",
    nameEn: "Headwear",
    url: "https://kaspreadsheet.com/search-916/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20cream%20colored%20baseball%20cap%20with%20subtle%20embroidered%20detail%20placed%20on%20smooth%20sandstone%20surface%2C%20warm%20golden%20hour%20sunlight%2C%20soft%20desert%20tones%2C%20clean%20editorial%20style%2C%20simple%20composition%2C%20modern%20minimal%20aesthetic%20with%20warm%20atmosphere&width=800&height=1000&seq=hb-cat-v2-headwear-3f8i&orientation=portrait",
    description: "Bonés, gorros e acessórios para cabeça estilosos",
  },
  {
    name: "Sets",
    nameEn: "Sets",
    url: "https://kaspreadsheet.com/search-917/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20fashion%20photography%20of%20coordinated%20two%20piece%20linen%20set%20in%20soft%20sage%20green%20laid%20on%20cream%20cotton%20backdrop%2C%20gentle%20diffused%20daylight%2C%20muted%20botanical%20tones%2C%20editorial%20style%2C%20fabric%20texture%20clearly%20visible%2C%20clean%20harmonious%20composition%2C%20relaxed%20luxury%20aesthetic&width=800&height=1000&seq=hb-cat-v2-sets-2g7j&orientation=portrait",
    description: "Conjuntos coordenados para looks completos e harmônicos",
  },
  {
    name: "Underwear/Underpants",
    nameEn: "Underwear",
    url: "https://kaspreadsheet.com/search-918/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20flat%20lay%20of%20soft%20organic%20cotton%20underwear%20in%20warm%20sand%20color%20neatly%20arranged%20on%20light%20marble%20surface%2C%20soft%20diffused%20studio%20light%2C%20warm%20neutral%20tones%2C%20clean%20elegant%20aesthetic%2C%20simple%20refined%20composition%2C%20modern%20intimate%20apparel%20style%2C%20premium%20quality%20look&width=800&height=1000&seq=hb-cat-v2-underwear-1h6k&orientation=portrait",
    description: "Roupas íntimas de algodão premium com conforto superior",
  },
  {
    name: "Jersey",
    nameEn: "Jersey",
    url: "https://kaspreadsheet.com/search-919/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20sportswear%20photography%20of%20vibrant%20coral%20red%20athletic%20jersey%20draped%20over%20light%20concrete%20surface%2C%20bright%20natural%20daylight%2C%20energetic%20warm%20tones%2C%20editorial%20sports%20style%2C%20mesh%20fabric%20detail%20visible%2C%20clean%20dynamic%20composition%2C%20modern%20athletic%20aesthetic&width=800&height=1000&seq=hb-cat-v2-jersey-0i5l&orientation=portrait",
    description: "Camisas esportivas e jerseys autênticos de times",
  },
  {
    name: "Accessories",
    nameEn: "Accessories",
    url: "https://kaspreadsheet.com/search-920/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20flat%20lay%20photography%20of%20minimalist%20gold%20tone%20watch%20and%20thin%20chain%20bracelet%20arranged%20on%20warm%20cream%20linen%20surface%2C%20soft%20natural%20light%20creating%20gentle%20shadows%2C%20warm%20elegant%20tones%2C%20editorial%20jewelry%20style%2C%20clean%20sophisticated%20composition%2C%20modern%20luxury%20minimal%20aesthetic&width=800&height=1000&seq=hb-cat-v2-accessories-9j4m&orientation=portrait",
    description: "Acessórios de moda que complementam seu estilo",
  },
  {
    name: "Bags",
    nameEn: "Bags",
    url: "https://kaspreadsheet.com/search-921/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20cognac%20brown%20leather%20crossbody%20bag%20placed%20on%20light%20oak%20wooden%20surface%2C%20warm%20natural%20window%20light%2C%20rich%20earthy%20tones%2C%20editorial%20fashion%20style%2C%20leather%20grain%20texture%20clearly%20visible%2C%20clean%20elegant%20composition%2C%20modern%20artisan%20aesthetic&width=800&height=1000&seq=hb-cat-v2-bags-8k3n&orientation=portrait",
    description: "Bolsas e mochilas premium para uso diário",
  },
  {
    name: "Belts",
    nameEn: "Belts",
    url: "https://kaspreadsheet.com/search-922/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20flat%20lay%20of%20braided%20tan%20leather%20belt%20elegantly%20coiled%20in%20circular%20shape%20on%20warm%20travertine%20stone%20surface%2C%20soft%20afternoon%20sunlight%2C%20warm%20caramel%20and%20sand%20tones%2C%20clean%20editorial%20style%2C%20leather%20texture%20detail%20visible%2C%20simple%20sophisticated%20composition%2C%20modern%20craft%20aesthetic&width=800&height=1000&seq=hb-cat-v2-belts-7l2o&orientation=portrait",
    description: "Cintos de couro genuíno com fivelas elegantes",
  },
  {
    name: "Perfumes",
    nameEn: "Perfumes",
    url: "https://kaspreadsheet.com/search-923/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20product%20photography%20of%20elegant%20amber%20glass%20perfume%20bottle%20with%20simple%20label%20on%20warm%20marble%20surface%2C%20soft%20golden%20hour%20light%20streaming%20through%2C%20warm%20amber%20and%20sand%20tones%2C%20editorial%20beauty%20style%2C%20clean%20sophisticated%20composition%2C%20modern%20luxury%20minimal%20aesthetic%2C%20subtle%20reflection&width=800&height=1000&seq=hb-cat-v2-perfumes-6m1p&orientation=portrait",
    description: "Perfumes importados com fragrâncias exclusivas e duradouras",
  },
  {
    name: "Other Stuff",
    nameEn: "Other",
    url: "https://kaspreadsheet.com/search-924/name/Shoes.html",
    image: "https://readdy.ai/api/search-image?query=Minimalist%20flat%20lay%20photography%20of%20assorted%20lifestyle%20products%20including%20ceramic%20mug%20notebook%20and%20wooden%20desk%20accessories%20arranged%20on%20warm%20cream%20linen%20surface%2C%20soft%20natural%20daylight%2C%20neutral%20earth%20tones%2C%20editorial%20still%20life%20style%2C%20clean%20harmonious%20composition%2C%20modern%20home%20aesthetic&width=800&height=1000&seq=hb-cat-v2-other-5n0q&orientation=portrait",
    description: "Outros produtos diversos com ótimo custo-benefício",
  },
];

export const seoSections = {
  whatIs: {
    title: "O que é o Hoobuy Spreadsheet?",
    content:
      "O Hoobuy Spreadsheet é uma lista organizada e verificada de produtos chineses que podem ser adquiridos através do agente Hoobuy. Esta ferramenta permite comparar preços, qualidade e vendedores em um único lugar, economizando tempo e dinheiro. Atualizado diariamente, o Hoobuy Spreadsheet é a forma mais rápida e eficiente de encontrar produtos baratos diretamente da China, com informações detalhadas sobre cada item.",
  },
  howItWorks: {
    title: "Como funciona o Hoobuy Spreadsheet?",
    steps: [
      {
        step: "01",
        title: "Escolha um produto",
        description:
          "Navegue pela lista completa do Hoobuy Spreadsheet e encontre o produto que deseja comprar. Todos os itens são verificados e organizados por categoria.",
      },
      {
        step: "02",
        title: "Copie o link do spreadsheet",
        description:
          "Copie o link do produto selecionado no Hoobuy Spreadsheet. Cada produto possui informações detalhadas sobre preço, vendedor e avaliações.",
      },
      {
        step: "03",
        title: "Use o agente Hoobuy para comprar",
        description:
          "Acesse o agente Hoobuy, cole o link do produto e finalize a compra. O agente cuida de toda a logística de importação e envio internacional.",
      },
      {
        step: "04",
        title: "Receba em casa",
        description:
          "Após a confirmação do pedido, o produto é enviado diretamente para o seu endereço. Acompanhe o status da entrega em tempo real pelo painel do agente.",
      },
    ],
  },
  benefits: {
    title: "Por que usar o Hoobuy Spreadsheet?",
    items: [
      {
        title: "Produtos mais baratos",
        description: "Acesso direto a fabricantes chineses com preços muito abaixo do mercado internacional.",
      },
      {
        title: "Comparação em tempo real",
        description: "Compare preços, qualidade e avaliações de diferentes vendedores em um só lugar.",
      },
      {
        title: "Itens exclusivos",
        description: "Encontre produtos que não estão disponíveis em lojas tradicionais do seu país.",
      },
      {
        title: "Atualização constante",
        description: "O Hoobuy Spreadsheet é atualizado diariamente com novos produtos e ofertas.",
      },
    ],
  },
  comparison: {
    title: "Hoobuy vs Outros Agentes de Compra",
    platforms: [
      { name: "Hoobuy Spreadsheet", price: "Baixo", speed: "Médio", reliability: "Alto", spreadsheet: "Sim" },
      { name: "Pandabuy", price: "Médio", speed: "Alto", reliability: "Alto", spreadsheet: "Sim" },
      { name: "Sugargoo", price: "Médio", speed: "Médio", reliability: "Médio", spreadsheet: "Sim" },
      { name: "CSSBuy", price: "Baixo", speed: "Baixo", reliability: "Médio", spreadsheet: "Não" },
    ],
  },
  safety: {
    title: "O Hoobuy é seguro?",
    points: [
      "Sim, o Hoobuy é uma plataforma confiável, mas é importante sempre verificar as avaliações dos vendedores antes de comprar.",
      "Utilize apenas agentes confiáveis e bem avaliados pela comunidade para evitar problemas com pedidos.",
      "Evite comprar produtos que não possuem avaliações ou fotos reais dos compradores anteriores.",
      "O Hoobuy Spreadsheet lista apenas produtos de vendedores verificados, aumentando a segurança das suas compras.",
    ],
  },
};

export const testimonials = [
  {
    name: "Maria Silva",
    role: "Compradora Frequente",
    text: "O Hoobuy Spreadsheet mudou completamente a forma como compro produtos da China. Encontrei itens incríveis por metade do preço que pagava antes.",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Brazilian%20woman%20with%20warm%20genuine%20smile%20and%20wavy%20dark%20hair%2C%20soft%20cream%20studio%20background%2C%20natural%20window%20lighting%2C%20editorial%20portrait%20style%2C%20clean%20simple%20composition%2C%20approachable%20friendly%20expression&width=200&height=200&seq=hb-avatar-v2-maria&orientation=squarish",
  },
  {
    name: "João Costa",
    role: "Revendedor",
    text: "Como revendedor, preciso de preços competitivos. O Hoobuy Spreadsheet me dá acesso aos melhores fornecedores chineses com informações atualizadas diariamente.",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Brazilian%20man%20with%20confident%20relaxed%20expression%20and%20short%20dark%20hair%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting%2C%20editorial%20portrait%20style%2C%20simple%20composition%2C%20friendly%20professional%20look&width=200&height=200&seq=hb-avatar-v2-joao&orientation=squarish",
  },
  {
    name: "Ana Rodrigues",
    role: "Entusiasta de Moda",
    text: "A variedade de produtos de moda no Hoobuy Spreadsheet é impressionante. Já comprei tênis, jaquetas e acessórios com qualidade excelente e preços imbatíveis.",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20young%20Brazilian%20woman%20with%20bright%20expressive%20eyes%20and%20curly%20brown%20hair%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting%2C%20editorial%20portrait%20style%2C%20simple%20composition%2C%20warm%20friendly%20expression&width=200&height=200&seq=hb-avatar-v2-ana&orientation=squarish",
  },
  {
    name: "Pedro Santos",
    role: "Colecionador",
    text: "Encontrei itens exclusivos que não existem em nenhuma loja do Brasil. O Hoobuy Spreadsheet é uma ferramenta indispensável para quem busca produtos únicos.",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Brazilian%20man%20with%20thoughtful%20intelligent%20expression%20and%20short%20beard%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting%2C%20editorial%20portrait%20style%2C%20simple%20composition%2C%20relaxed%20genuine%20look&width=200&height=200&seq=hb-avatar-v2-pedro&orientation=squarish",
  },
  {
    name: "Carla Mendes",
    role: "Designer de Moda",
    text: "A curadoria de produtos do Hoobuy Spreadsheet é excepcional. Consigo acompanhar as tendências e encontrar peças de alta qualidade para minhas coleções.",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20Brazilian%20woman%20with%20creative%20artistic%20expression%20and%20sleek%20dark%20hair%2C%20clean%20cream%20studio%20background%2C%20soft%20natural%20lighting%2C%20editorial%20portrait%20style%2C%20simple%20composition%2C%20sophisticated%20friendly%20look&width=200&height=200&seq=hb-avatar-v2-carla&orientation=squarish",
  },
];